<template>
  <div>
    <van-sticky>
      <van-search v-model="value" shape="round" background="#e93323" placeholder="请输入搜索关键词" @search="onSearch"
        @clear="onClear">
      </van-search>
    </van-sticky>
  </div>
</template>

<script>
  import Vue from 'vue';
  import {
    Search,
    Sticky,
    Toast
  } from 'vant';
  Vue.use(Search).use(Sticky).use(Toast);
  export default {
    name: 'Search',

    data() {
      return {
        value: ''
      }
    },
    mounted() {

    },
    methods: {
      onSearch(value) {
        if (value == '') {
          this.$dialog.error('请输入关键词')
          return;
        }
        this.$emit('getKeyword', value)
      },
      onClear() {
        this.$emit('getKeyword', '')
      }
    },
  }
</script>

<style scoped>
  .collect-store {
    color: #fff;
  }
</style>
